"use client";

import { createContext, useContext, useState } from 'react';

type AdminContextType = {
  isAdmin: boolean;
  setIsAdmin: (v: boolean) => void;
  isMemberMode: boolean;
  setIsMemberMode: (v: boolean) => void;
};

const AdminContext = createContext<AdminContextType>({
  isAdmin: false,
  setIsAdmin: () => {},
  isMemberMode: false,
  setIsMemberMode: () => {},
});

export function AdminProvider({ children }: { children: React.ReactNode }) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isMemberMode, setIsMemberMode] = useState(false);

  return (
    <AdminContext.Provider value={{ isAdmin, setIsAdmin, isMemberMode, setIsMemberMode }}>
      {children}
    </AdminContext.Provider>
  );
}

export function useAdmin() {
  return useContext(AdminContext);
}
